import styled from 'styled-components/native';


export const Container = styled.ScrollView`
	background-color: ${({ theme }) => theme.components.screen.background};
	min-height: 100%;
	padding: 23px;
`;

